module.exports = __webpack_public_path__ + "67cea085680c4ed90753fbcee6ebd7e8.svg";